<script lang="ts">
  import Fa from 'svelte-fa';
  import {faStar} from '@fortawesome/free-solid-svg-icons';

  export let stars = 0;
  export let icon = faStar;

  let padding = 0;
  $: padding = icon == faStar ? 0 : 4;

  let starsReal: number;
  $: starsReal = Math.min(5, Math.max(0, Math.round(stars)));
</script>

<span class="text-nowrap">
  {#if starsReal !== 0}<span class="bg-dark text-light p-1 rounded">{#each Array(starsReal) as _, _2}<span style={`padding: 0 ${padding}px`}><Fa {icon}/></span>{/each}</span>{/if}{#if starsReal !== 5}<span class="bg-light text-secondary p-1 rounded">{#each Array(5 - starsReal) as _, _2}<span style={`padding: 0 ${padding}px`}><Fa {icon}/></span>{/each}</span>{/if}
</span>